module.exports = __webpack_public_path__ + "media/auth/login-background-1-7c9a5dcd.jpg";